import type { TOptions } from 'i18next';
import type { App } from 'vue';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import { useI18n } from '@modules/i18n/composables';

export default function registerPluginI18next(app: App): void {
  void i18next.init({
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    load: 'currentOnly',
    ns: ['default'],
  });

  app.use(I18NextVue, { i18next });

  const { getTPath } = useI18n();

  app.config.globalProperties.$getTranslation = (group: symbol, shortKey: string, options?: TOptions): string => (
    app.config.globalProperties.$t(getTPath(group, shortKey), options)
  );

  app.config.globalProperties.$getTPath = getTPath;
}
